export class AppointmentTypesConstants {
    static INITIAL_ASSESSMENT = "ca78f009-0e8c-4ac9-9c98-c51c48bf7d45";
}